import { Component, Input } from '@angular/core';
import {
  OccupationOfLanePlacementConstructionObjectsFormValue
} from '../../forms/occupation-of-lane-placement-construction-objects.form';
import {
  LocationDecisionsPreviewComponent
} from '../../../../../common/components/location-decisions/location-decisions-preview/location-decisions-preview.component';
import {DatePipe, DecimalPipe} from '@angular/common';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  RoadOccupationStageTableComponent
} from '../../../../../common/occupation-data-section/components/road-occupation-stage-table/road-occupation-stage-table.component';
import {ToNumberPipe} from "../../../../../../../../pipes/to-number.pipe";

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-preview',
  standalone: true,
  imports: [
    LocationDecisionsPreviewComponent,
    DatePipe,
    LabelComponent,
    ParcelsPreviewComponent,
    RoadOccupationStageTableComponent,
    DecimalPipe,
    ToNumberPipe
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-preview.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsPreviewComponent {
  @Input()
  public occupation: OccupationOfLanePlacementConstructionObjectsFormValue | undefined;
}
